function a(){dataLayer.push(arguments)}window.dataLayer=window.dataLayer||[],a("js",new Date),a("config","AW-16844203503"),a("config","AW-17795019698"); 